import {
  formatBadStatus,
  formatErrorArray,
  formatErrorsWithCode,
  formatMalformed,
  formatUnmatched,
} from './formatErrors'
import { formatSuccessResponse } from './formatResponses'

type JSONResponse = Record<string, unknown> & {
  status?: string | number
  meta?: Record<string, unknown>
  errors?: unknown[]
  data?: unknown[]
  result?: unknown
  error?: string
  'error-details'?: {
    code: string
    failures?: Record<string, unknown[]>
  }
  errorDetails?: unknown
}

type ErrorObject = {
  code: number | string
  message: string
  errors: Record<string, unknown>
  errorDetails?: unknown
}

/**
 * This code has been largely untouched since it was first committed by
 * @garethtalty in 2016. You can see the original file's history here:
 * https://github.com/Gousto/Gousto2-FrontEnd/blob/750691d7/src/nodeserver/src/utils/jsonHelper.js
 */
export function processJSON([response, status]: [JSONResponse, number]) {
  return new Promise((resolve, reject) => {
    const meta = response.meta || null
    if (response.status === 'ok') {
      return resolve(formatSuccessResponse(response as JSONResponse & { status: 'ok' }, meta))
    } else if (Array.isArray(response.errors)) {
      try {
        return reject(formatErrorsWithCode(response.errors))
      } catch (err) {
        return reject(formatErrorArray(response.errors))
      }
    } else if (Array.isArray(response.data)) {
      return reject(formatErrorArray(response.data))
    } else if (response.error) {
      const errorObj: ErrorObject = {
        code: 500,
        message: response.error,
        errors: {},
      }
      if (response['error-details']) {
        errorObj.code = response['error-details'].code
        errorObj.errors = Object.entries(response['error-details'].failures || {}).reduce(
          (result, [key, errors]) => {
            // eslint-disable-next-line no-param-reassign,prefer-destructuring
            result[key] = errors[0]

            return result
          },
          {} as Record<string, unknown>,
        )
      }

      if (response.errorDetails) {
        errorObj.errorDetails = response.errorDetails
      }

      return reject(errorObj)
    } else if (typeof response === 'object' && status < 400) {
      return resolve(formatBadStatus(response, meta))
    } else if (typeof response === 'object') {
      return reject(formatUnmatched(response))
    } else {
      return reject(formatMalformed())
    }
  })
}
